module.exports = __webpack_public_path__ + "static/media/Survivor.f5d6b542.png";